import { getPartnerDetails } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import { useCallback } from 'react';
import { useAsync } from 'react-async';
export const usePartnerDetails = (mpacBaseUrl, partnerId) => {
  const promiseFn = useCallback((_, {
    signal
  }) => getPartnerDetails(mpacBaseUrl, partnerId, {
    signal
  }), [mpacBaseUrl, partnerId]);
  const {
    data,
    error,
    isPending,
    isRejected,
    reload,
    cancel
  } = useAsync({
    promiseFn
  });

  if (isRejected) {
    log.error('ManagePartnersRoutes/hooks', 'Failed to retrieve partner details', {
      error
    });
  }

  return {
    isPartnerDetailsPending: isPending,
    isPartnerDetailsRejected: isRejected,
    partnerDetailsError: error,
    partnerDetails: data,
    reloadPartnerDetails: reload,
    cancelPartnerDetails: cancel
  };
};